import React from 'react';
import PropTypes from 'prop-types';
import { getAdSize, getAdClass, getAlmostRandomId } from './holid-ad-helper';
import HolidAd from './holid-ad';
import styles from './holid-ad.module.scss';

const HolidAdWrapper = ({ adFormats, text, className }) => {
    const adClass = getAdClass(adFormats);
    const adSize = getAdSize(adFormats);
    const id = `${getAlmostRandomId()}-${adClass}`;
    return (
        <div
            id={`holid-ad-wrapper-${id}`}
            className={`${styles.holidAd} ${styles.holidAdLoaded} ${
                className ? className : ''
            }`}
            style={{
                width: adSize[0],
                height: adSize[1]
            }}
            data-label-text={text}>
            <HolidAd id={id} adClass={adClass} />
        </div>
    );
};

HolidAdWrapper.propTypes = {
    className: PropTypes.string,
    adFormats: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
};

HolidAdWrapper.defaultProps = {
    text: 'Annons'
};

export default HolidAdWrapper;
